(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glintac-most-wanted"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__glintacMostWantedInit) return;
  window.__glintacMostWantedInit = true;
  function update(track) {
    var w = track.clientWidth;
    if (!w) return;
    var index = Math.round(track.scrollLeft / w);
    var product = track.closest('.glintac-most-wanted__product');
    if (!product) return;
    var dots = product.querySelectorAll('.glintac-most-wanted__dot');
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('glintac-most-wanted__dot--active', i === index);
    }
  }
  // One delegated, passive listener for every product image carousel (scroll doesn't bubble, so capture)
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('glintac-most-wanted__media-carousel')) return;
    if (t.__gmwRaf) return;
    t.__gmwRaf = requestAnimationFrame(function () {
      t.__gmwRaf = 0;
      update(t);
    });
  }, { capture: true, passive: true });

  // Add to cart without leaving the page (no redirect to /cart)
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('glintac-most-wanted__form')) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (!btn || btn.__gmwBusy) return;
    btn.__gmwBusy = true;
    var label = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        // Let the theme refresh its cart icon / count
        try {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'glintac-most-wanted', data: { source: 'glintac-most-wanted', itemCount: cart.item_count } }
          }));
        } catch (err) {}
        // Fallback: update common cart count bubbles in the header
        var counts = document.querySelectorAll('.cart-bubble__text-count, .cart-count-bubble span[aria-hidden="true"], [data-cart-count]');
        for (var i = 0; i < counts.length; i++) counts[i].textContent = cart.item_count;
        btn.textContent = 'Added \u2713';
        setTimeout(function () {
          btn.textContent = label;
          btn.disabled = false;
          btn.__gmwBusy = false;
        }, 1800);
      })
      .catch(function () {
        // If anything fails, fall back to the normal add-to-cart behavior
        btn.textContent = label;
        btn.disabled = false;
        btn.__gmwBusy = false;
        form.submit();
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glintac-package-builder"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(location.pathname.indexOf('/cart')<0||location.search.indexOf('gp_buy=1')<0)return;
  var tries=0,tm=setInterval(function(){
    var b=document.querySelector('.gokwik-checkout button, #gokwik-checkout-button, button[name="checkout"], input[name="checkout"], [name="checkout"]');
    if(b||++tries>40){clearInterval(tm);if(b)b.click()}
  },250);
})();
(function(){
function init(root){
  if(root.dataset.ready)return;root.dataset.ready='1';
  var D=root.dataset,base=+D.base,CQ=+D.cq,WQ=+D.wq;
  var fmt=function(n){return new Intl.NumberFormat('en-IN',{style:'currency',currency:D.cur,maximumFractionDigits:0}).format(n)};
  var $=function(s,c){return (c||root).querySelector(s)},$$=function(s,c){return Array.prototype.slice.call((c||root).querySelectorAll(s))};
  var esc=function(t){var d=document.createElement('div');d.textContent=t;return d.innerHTML};
  var G={c:{limit:CQ,items:{}},w:{limit:WQ,items:{}}};
  var cnt=function(g){return Object.keys(G[g].items).reduce(function(a,k){return a+G[g].items[k].qty},0)};
  $$('[data-base-fmt]').forEach(function(e){e.textContent=fmt(base)});

  function info(card){var v=$('.gp-var',card),o=v.tagName==='SELECT'?v.selectedOptions[0]:v;
    var vt=o.dataset.vt;return{vid:o.value,pid:card.dataset.id,title:card.dataset.title+(vt&&vt!=='Default Title'?' – '+vt:''),img:card.dataset.img,price:+o.dataset.price,stock:+o.dataset.stock,up:+card.dataset.up}}
  function toggle(card,d){var g=card.dataset.g,grp=G[g],i=info(card),it=grp.items[i.vid];
    if(d>0){
      if(grp.limit===1){grp.items={};if(!it)grp.items[i.vid]={i:i,qty:1}}
      else{if(cnt(g)>=grp.limit||(it&&it.qty>=i.stock))return;if(it)it.qty++;else grp.items[i.vid]={i:i,qty:1}}
    }else if(it){it.qty--;if(it.qty<1)delete grp.items[i.vid]}
    render()}
  function go(id){var e=document.getElementById(id);if(e)e.scrollIntoView({behavior:'smooth',block:'start'})}

  root.addEventListener('click',function(e){
    var card=e.target.closest('.gp-card');if(!card||card.classList.contains('gp-out')||e.target.closest('.gp-var'))return;
    var b=e.target.closest('[data-d]'),before=[cnt('c')>=CQ,cnt('w')>=WQ];
    toggle(card,b?+b.dataset.d:1);
    var after=[cnt('c')>=CQ,cnt('w')>=WQ];
    if(!before[0]&&after[0]&&!after[1])go('gp-w');else if(!(before[0]&&before[1])&&after[0]&&after[1])go('gp-sum')});
  root.addEventListener('keydown',function(e){if((e.key==='Enter'||e.key===' ')&&e.target.classList.contains('gp-card')){e.preventDefault();e.target.click()}});
  root.addEventListener('change',function(e){var v=e.target.closest('.gp-var');if(!v)return;var card=v.closest('.gp-card'),g=card.dataset.g;
    Object.keys(G[g].items).forEach(function(k){if(G[g].items[k].i.pid===card.dataset.id)delete G[g].items[k]});render()});
  $('#gp-reset').onclick=function(){G.c.items={};G.w.items={};render();go('gp-c')};

  function render(){
    $$('.gp-card').forEach(function(card){
      var g=card.dataset.g,grp=G[g],i=info(card),it=grp.items[i.vid],q=it?it.qty:0,full=cnt(g)>=grp.limit&&grp.limit>1&&!q;
      card.classList.toggle('sel',q>0);card.classList.toggle('gp-full2',full);
      $('.gp-pr',card).textContent='Individual price '+fmt(i.price/100);
      var t=$('.gp-tag',card);if(t){if(D.upvar)t.textContent='PREMIUM +'+fmt(i.up);else t.hidden=true}
      var qb=$('.gp-qty',card),sel=$('.gp-sel',card);
      if(!card.classList.contains('gp-out')){
        if(grp.limit>1&&q>0){qb.hidden=false;sel.hidden=true;$('b',qb).textContent=q;$('[data-d="1"]',qb).disabled=cnt(g)>=grp.limit||q>=i.stock}
        else{qb.hidden=true;sel.hidden=false;sel.textContent=q?'Selected':(full?'Limit reached':'Select')}}
    });
    var lines=[],up=0;
    ['c','w'].forEach(function(g){var arr=[];Object.keys(G[g].items).forEach(function(k){var x=G[g].items[k];for(var n=0;n<x.qty;n++)arr.push(x.i)});
      for(var n=0;n<G[g].limit;n++){var i=arr[n],label=(g==='c'?'Chandelier':'Wall light')+(G[g].limit>1?' '+(n+1):'');
        if(i){var iu=D.upvar?i.up:0;up+=iu;lines.push('<li>'+(i.img?'<img src="'+i.img+'" alt="">':'<div class="gp-ph"></div>')+'<div><small>'+label+'</small>'+esc(i.title)+(iu?'<small class="gp-gold">Premium upgrade + '+fmt(iu)+'</small>':'')+'</div></li>')}
        else lines.push('<li class="gp-empty"><div class="gp-ph"></div><div><small>'+label+'</small>Not chosen yet</div></li>')}});
    var cc=cnt('c'),wc=cnt('w'),done=cc>=CQ&&wc>=WQ,left=WQ-wc;
    $('#gp-lines').innerHTML=lines.join('');$('#gp-up').textContent=up?'+ '+fmt(up):fmt(0);$('#gp-up').parentNode.style.display=D.upvar?'':'none';$('#gp-tot').textContent=fmt(base+up);
    $('[data-cnt="c"]').textContent=cc+' of '+CQ+' selected';$('[data-cnt="w"]').textContent=wc+' of '+WQ+' selected';
    $('#gp-add').disabled=!done;$('#gp-buy').disabled=!done;
    $('#gp-hint').textContent=done?'Package complete. Price includes GST and free delivery across India.':(cc<CQ?'Next: choose your chandelier.':'Next: choose '+left+' more wall light'+(left>1?'s':'')+'.');
    $('#gp-barT').textContent=(cc+wc)+'/'+(CQ+WQ)+' selected · '+fmt(base+up);
    var st=[['1 Chandelier',cc>=CQ],['2 Wall lights ('+wc+'/'+WQ+')',wc>=WQ],['3 Review & add',false]];
    $('#gp-prog').innerHTML=st.map(function(s,n){var cur=(n===0&&cc<CQ)||(n===1&&cc>=CQ&&wc<WQ)||(n===2&&done);return '<span class="'+(s[1]?'ok':cur?'on':'')+'">'+(s[1]?'✓ ':'')+s[0]+'</span>'}).join('');
    root._up=up;
  }

  function addAll(then){
    var err=$('#gp-err'),pid='GP-'+Date.now().toString(36).toUpperCase(),items=[],btns=[$('#gp-add'),$('#gp-buy')],up=root._up||0;
    err.hidden=true;
    if(D.mode!=='lines'){
      if(!D.bundle){err.textContent='Package product is not set in the section settings.';err.hidden=false;return}
      var props={'Package':D.name,'Package ID':pid},w=0;
      ['c','w'].forEach(function(g){Object.keys(G[g].items).forEach(function(k){var x=G[g].items[k];
        props[(g==='c'?'Chandelier':'Wall light '+(++w))+(x.qty>1?' (x'+x.qty+')':'')]=x.i.title+' [variant '+x.i.vid+']'})});
      items.push({id:+D.bundle,quantity:1,properties:props});
    }else{
      ['c','w'].forEach(function(g){Object.keys(G[g].items).forEach(function(k){var x=G[g].items[k];
        items.push({id:+x.i.vid,quantity:x.qty,properties:{'_Package':D.name,'_Package ID':pid}})})});
    }
    if(up>0&&D.upvar)items.push({id:+D.upvar,quantity:up,properties:{'Package ID':pid,'Premium upgrade':fmt(up)}});
    btns.forEach(function(b){b.disabled=true});
    fetch(D.add,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error(j.description||'Could not add to cart');return j})})
      .then(function(){window.location.href=then==='buy'?D.cart+(D.cart.indexOf('?')<0?'?':'&')+'gp_buy=1':D.cart})
      .catch(function(e){err.textContent=e.message;err.hidden=false;render()});
  }
  $('#gp-add').onclick=function(){addAll('cart')};
  $('#gp-buy').onclick=function(){addAll('buy')};
  render();
}
function all(){Array.prototype.forEach.call(document.querySelectorAll('.gp'),init)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
document.addEventListener('shopify:section:load',all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
